import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Panel } from '../ui/Modal';
import h from './Home.module.css';
import { Backdrop, PublicRooms } from './Home';

export function RoomsBrowser() {
  const { t } = useTranslation();
  return (
    <div className={h.page}>
      <Backdrop />
      <header className={h.hero}>
        <h1 className={h.title} style={{ fontSize: 40 }}>
          {t('home.publicRooms')}
        </h1>
      </header>
      <main className={h.content}>
        <Panel className={h.cardWide}>
          <PublicRooms />
          <div className={h.links}>
            <Link to="/">{t('common.back')}</Link>
          </div>
        </Panel>
      </main>
    </div>
  );
}
